import { signal } from '@preact/signals-react';
import { createContext, useContext } from 'react';
export const projectStateSignal = signal({ phase: 'loading' });
export const setProjectStateSignal = (state) => {
    projectStateSignal.value = state;
};
export const EditorContext = createContext({});
export const useEditorContext = () => useContext(EditorContext);
